
  import {Component, Vue} from 'vue-property-decorator';
  import {ICar} from "@/modules/Car/interfaces/car.interface";
  import moment from "moment";
  import AppSwitch from "@/components/AppSwitch.vue";
  import {isMobileOnly} from "mobile-device-detect";
  import CarNumberInput from "@/components/CarNumberInput.vue";
  import {KeyboardMobileHidden} from "@/plugins/keyboard-mobile-hidden";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import FormBuilderField from "@/modules/FormBuilder/components/FormBuilderField.vue";
  import {IApp} from "@/interfaces/app.interface";
  import CarInfoDateTime from "@/modules/Car/components/carInfoControls/CarInfoDateTime.vue";
  import {ICarStore} from "@/modules/Car/interfaces/car-store.interface";
  import NoAccessMessage from "@/modules/Car/components/carInfoControls/NoAccessMessage.vue";
  import WarningMessage from "@/modules/Car/components/carInfoControls/WarningMessage.vue";
  import CarNumberBlock from "@/modules/Car/components/carInfoControls/CarNumberBlock.vue";
  import FieldPersName from "@/modules/Car/components/carInfoControls/BaseFormInfoField.vue";
  import BaseFormInfoField from "@/modules/Car/components/carInfoControls/BaseFormInfoField.vue";
  import PayGuestHoursField from "@/modules/Car/components/carInfoControls/PayGuestHoursField.vue";
  import GuestFlagField from "@/modules/Car/components/carInfoControls/GuestFlagField.vue";
  import DisableCancelMovsField from "@/modules/Car/components/carInfoControls/DisableCancelMovsField.vue";
  import TarifFields from "@/modules/Car/components/carInfoControls/TarifFields.vue";
  import CorpField from "@/modules/Car/components/carInfoControls/CorpField.vue";
  import EmailAndAccountField from "@/modules/Car/components/carInfoControls/EmailAndAccountField.vue";
  import ParksField from "@/modules/Car/components/carInfoControls/ParksField.vue";
  import CarTypeField from "@/modules/Car/components/carInfoControls/CarTypeField.vue";
  import FreeSaldoFlagField from "@/modules/Car/components/carInfoControls/FreeSaldoFlagField.vue";
  import PhoneField from "@/modules/Car/components/carInfoControls/PhoneField.vue";
  import AdditionalBtnsWrapper from "@/modules/Car/components/carInfoControls/AdditionalBtnsWrapper.vue";
  import {compareHelper} from "@/helpers/compareHelper";
  import {ICarRequest} from "@/modules/Car/interfaces/car-request.interface";
  import { IAppState } from '@/interfaces/app-state.interface';
  import LevenshteinFlagField from "@/modules/Car/components/carInfoControls/LevenshteinFlagField.vue";

  @Component({
    components: {
      LevenshteinFlagField,
      AdditionalBtnsWrapper,
      PhoneField,
      FreeSaldoFlagField,
      CarTypeField,
      ParksField,
      EmailAndAccountField,
      CorpField,
      TarifFields,
      DisableCancelMovsField,
      GuestFlagField,
      PayGuestHoursField,
      BaseFormInfoField,
      FieldPersName,
      CarNumberBlock,
      WarningMessage,
      NoAccessMessage,
      CarInfoDateTime,
      AppSwitch,
      CarNumberInput,
      FormBuilderField,
    },
  })
  export default class CarInfo extends Vue {
    $refs: any;
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    isMobileOnly;
    visibleDropdown = false;
    format = 'timestamp';
    requestLoading = false;
    animateWarning = false;
    hasChanges = false;
    displayWarning = false;
    dateEndInvalid = false;
    accessToInfo = true;
    dateFormats = IApp.DateFormats;

    get storeState(): IAppState { return this.$store.state; }
    get formRules() {
      return {
        carNumber: [{
          validator: (rule, value, callback) => {
            let valid = false;
            if (!!value) {
              if (!this.formModel.nonStandartFlag) valid = value.length >= 7 && value.length <= 9;
              else valid = true;
            }
            else valid = (!!this.formModel.email || !!this.formModel.phone) && !!this.formModel.corpId;
            return valid ? callback() : callback(new Error('Номер должен состоять из 7-9 знаков'))
          },
          required: true,
          message: 'Номер должен состоять из 7-9 знаков',
          trigger: 'blur'
        }],
        additionalCarNumber: [{
          validator: (rule, value, callback) => {
            let valid = true;
            if (!!value) {
              valid = value.length >= 7 && value.length <= 9;
            }
            return valid ? callback() : callback(new Error('Номер должен состоять из 7-9 знаков'))
          },
          required: true,
          message: 'Номер должен состоять из 7-9 знаков',
          trigger: 'blur'
        }],
        dateEnd: [{
          validator: (rule, value, callback) =>
            value && +moment(value).format('x') >= +moment().format('x') || !value
            ? callback()
            : callback(new Error(' ')),
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        dateBegTarif: [{
          validator: (rule, value, callback) => this.formModel.tarifId && value || !this.formModel.tarifId
            ? callback()
            : callback(new Error(' ')),
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
      };
    }

    get activeCar(): ICar.IEntity { return this.storeState.car.activeCar; }
    get createMode() { return this.storeState.car.createMode; }
    get popupPayload(): ICarStore.IPopupPayload { return this.storeState.car.popupPayload; }
    get defaultValues(): ICar.IEntity { return this.storeState.car.formData.defaultValues; }
    get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
    get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }

    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get viewMode() { return !this.userAccess.scCarMk; }
    get hasInArchive() { return this.formModel.carStatusId === ICar.CarStatusId.Archive; }

    get displayTarif() {
      let display = true;
      if (!this.userAccess.extModeFlag) display = false;
      if (!this.userAccess.scChangeTarif) display = false;
      if (this.userAccess.fillTarifFlag) display = true;

      return display;
    }
    get displayParks() {
      let display = true;

      if (!this.userAccess.extModeFlag) display = false;
      if (!this.userAccess.carsXParksFlag) display = false;
      if (this.userAccess.fillParkFlag) display = true;

      return display;
    }

    get canSaveInCreationMode() {
      let result = false;
      if (this.popupPayload.createMode && this.formModel.carNumber) result = true;
      return result;
    }

    async created() {
      this.isMobileOnly = isMobileOnly;

      const needRequired = [
        { condition: this.userAccess.fillParkFlag, propName: 'parks', },
        { condition: this.userAccess.fillTarifFlag, propName: 'tarifId', },
        { condition: this.userAccess.fillCarTypeFlag, propName: 'carTypeId', },
        { condition: this.createMode && this.userAccess.scCorpAdmin, propName: 'corpId', },
      ];
      needRequired.forEach(item => {
        if (item.condition) {
          Vue.set(this.formRules, item.propName, [{ required: true, message: ' ', trigger: 'blur' }]);
        }
      });

      await this.$store.dispatch('car/prepareCarInfo');
      this.accessToInfo = this.activeCar ? this.activeCar.scOpenCarCard : true;
      if (!this.userAccess.scEditCarWithFreeSaldoFlag && this.activeCar && this.activeCar.freeSaldoFlag) {
        this.accessToInfo = false;
      }
    }

    mounted() {
      if (this.createMode && !this.isMobileOnly) {
        this.$refs.CarNumberBlock.$refs.carNumber.setFocus();
      }

      KeyboardMobileHidden();
    }

    async confirmForm() {
      if (this.hasInArchive) this.formModel.dateEnd = '';
      this.$refs.carInfoForm.validate(async (valid) => {
        if (valid) {
          let car: any = {
            ...this.formModel,
          };
          if (car.corpName) car.corpId = null;
          const dateProps = ['dateBeg', 'dateEnd', 'dateBegTarif'];
          dateProps.forEach(date => car[date] = this.formModel[date] ? moment(this.formModel[date]).format(IApp.DateFormats.ToServer) : '');

          // Send props for creation trailer.
          if (this.popupPayload.createTrailer) {
            this.popupPayload.createTrailerProps.forEach(item => {
              car[item.prop] = item.value;
            });
          }

          let success = await this.$store.dispatch('car/saveCarData', {
            command: this.createMode ? ICarRequest.Command.Add : ICarRequest.Command.Update,
            car
          });
          if (success) {
            if (!this.popupPayload.customCreateNotification) {
              this.$notify({
                title: 'Успешно',
                message: !this.createMode ? 'Данные успешно изменены' : 'Автомобиль успешно добавлен',
                type: 'success'
              });
            }
            await this.onClose();
          }
          else {
            this.$notify.error({
              title: 'Ошибка',
              message: !this.createMode ? 'Данные не были изменены, попробуйте снова' : 'Автомобиль не был добавлен, повторите попытку',
            });
          }
        }
        else {
          return false;
        }
      });
    }

    async onClose() {
      await this.$store.dispatch('car/closeCarPopup');
    }

    async revertChanges() {
      this.$store.commit('car/setSubProperty', {
        block: 'formData',
        name: 'formModel',
        value: {...this.storeState.car.formData.defaultValues},
      });
      this.hasChanges = false;
      // this.animateWarning = false;
      // this.displayWarning = false;
      this.dateEndInvalid = false;
      await this.onClose();
    }

    formItemChange() {
      this.detectChanges();
    }

    detectChanges() {
      let simpleProps = ['disableLevenshteinFlag', 'carNumber', 'additionalCarNumber', 'freeSaldoFlag', 'persName', 'model', 'payGuestHours', 'guestFlag', 'disableCancelMovsFlag', 'comment', 'corpId', 'corpName', 'email', 'phone', 'tmPersonId', 'nonStandartFlag', 'carTypeId',];
      let simplePropsWithConditions = [
        { prop: 'parks', condition: this.displayParks, isArray: true, },
        { prop: 'tarifId', condition: this.displayTarif, },
      ];
      let dateProps = ['dateBeg', 'dateEnd',];
      if (this.displayTarif && this.formModel.tarifId) dateProps.push('dateBegTarif');

      const presetProps = [];
      const presetPropsObject: any = {};
      if (this.popupPayload.presetFields) {
        this.popupPayload.presetFields.forEach(field => {
          presetProps.push(field.prop);
          presetPropsObject[field.prop] = field.value;
        });
      }

      let hasChanges = false;

      if (this.userAccess.extModeFlag) {
        simpleProps.forEach(prop => {
          let diffWithPreset = this.popupPayload.createMode && presetProps.includes(prop) && presetPropsObject[prop] && presetPropsObject[prop] !== this.formModel[prop];
          if ((this.formModel[prop] !== this.startForm[prop] && !presetProps.includes(prop)) || diffWithPreset) hasChanges = true;
        });
        simplePropsWithConditions.forEach(item => {
          let diffWithPreset = this.popupPayload.createMode && presetProps.includes(item.prop) && presetPropsObject[item.prop] && presetPropsObject[item.prop] !== this.formModel[item.prop];
          let diffArrays = item.isArray && !this.compareArrays(this.formModel[item.prop], this.startForm[item.prop]);
          if ((item.condition && (item.isArray ? diffArrays : this.formModel[item.prop] !== this.startForm[item.prop]))
            && !presetProps.includes(item.prop)
            || diffWithPreset) {
            hasChanges = true;
          }
        });

        dateProps.forEach(prop => {
          let diffWithPreset = this.popupPayload.createMode && presetProps.includes(prop) && presetPropsObject[prop] && presetPropsObject[prop] !== this.formModel[prop];
          if ((this.compareDates(this.formModel[prop], this.startForm[prop]) && !presetProps.includes(prop)) || diffWithPreset) {
            hasChanges = true;

            if (prop === 'dateEnd' && this.formModel.dateEnd) {
              this.dateEndInvalid = +moment(this.formModel.dateEnd).format('x') < +moment().format('x');
            }
          }
        });
      }
      else {
        let easyProps = ['carNumber', 'persName', 'guestFlag',];
        if (this.displayParks) easyProps.push('parks');
        if (this.displayTarif) easyProps.push('tarifId');
        if (this.displayTarif && this.formModel.tarifId) easyProps.push('dateBegTarif');

        easyProps.forEach(prop => {
          let diffWithPreset = this.popupPayload.createMode && presetProps.includes(prop) && presetPropsObject[prop] && presetPropsObject[prop] !== this.formModel[prop];
          if ((this.formModel[prop] !== this.startForm[prop] && !presetProps.includes(prop)) || diffWithPreset) hasChanges = true;
        });
      }

      this.hasChanges = hasChanges;
      return hasChanges;
    }

    compareDates(date1: string, date2: string) {
      return compareHelper.compareDates(date1, date2);
    }

    compareArrays(arr1, arr2) {
      return compareHelper.compareArrays(arr1, arr2);
    }
  }
